import './SohoLoader.css'

const SIZE_CLASS = {
  sm: 'soho-loader--sm',
  md: 'soho-loader--md',
  lg: 'soho-loader--lg',
}

/**
 * Project-wide SoHo loading indicator (primary ring spinner).
 */
const SohoLoader = ({
  size = 'md',
  loading = true,
  message,
  className = '',
  fullScreen = false,
  'aria-label': ariaLabel = 'Loading',
}) => {
  if (!loading) return null

  const sizeClass = SIZE_CLASS[size] || SIZE_CLASS.md
  const content = (
    <div
      className={`soho-loader ${sizeClass} ${className}`.trim()}
      role="status"
      aria-live="polite"
      aria-label={message ? undefined : ariaLabel}
    >
      <div className="soho-loader__ring" aria-hidden="true" />
      {message ? <p className="soho-loader__message">{message}</p> : null}
    </div>
  )

  if (fullScreen) {
    return <div className="soho-loader__fullscreen">{content}</div>
  }

  return content
}

export default SohoLoader
